import React from 'react'

const Slide3 = () => {
  return (
    <div>
        <p>
        アイテムの装備が完了したらゲームスタートです。<br></br>
        難易度を選択し、遊びましょう！
        </p>
    </div>
  )
}

export default Slide3